import React from 'react';
import {
  Dropdown,
  DropdownAnchor,
  DropdownContent,
  DropdownMenu,
  MenuGroup,
  MenuItem,
  Values,
} from '@fiverr-private/dropdown';
import { Button } from '@fiverr-private/button';
import { Typography } from '@fiverr-private/typography';
import { ChevronDownIcon, ChevronUpIcon } from '@fiverr-private/visuals';
import { ItemValue } from '../../../../../../types';

interface MultiSelectProps {
  label: string;
  onChange: (values: Values) => void;
  value: ItemValue[];
  options: string[];
  activeFilters?: number;
}

export const MultiSelect = ({ label, onChange, value, options, activeFilters }: MultiSelectProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <Dropdown values={{ item: value }} onChange={onChange} onOpenChanged={setIsOpen}>
      <DropdownAnchor>
        <Button variant="ghost">
          <Typography as="p" color="grey_1200" fontWeight="semibold">
            {label}&nbsp;{!!activeFilters && `(${activeFilters})`}
          </Typography>
          {isOpen ? <ChevronUpIcon size="md" /> : <ChevronDownIcon size="md" />}
        </Button>
      </DropdownAnchor>
      <DropdownContent>
        <DropdownMenu>
          <MenuGroup isMulti>
            {options.map((value) => (
              <MenuItem key={value} value={value} selectable>
                {value}
              </MenuItem>
            ))}
          </MenuGroup>
        </DropdownMenu>
      </DropdownContent>
    </Dropdown>
  );
};
